import { render, staticRenderFns } from "./TextCom.vue?vue&type=template&id=05a5f1ce&scoped=true"
import script from "./TextCom.vue?vue&type=script&lang=js"
export * from "./TextCom.vue?vue&type=script&lang=js"
import style0 from "./TextCom.vue?vue&type=style&index=0&id=05a5f1ce&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05a5f1ce",
  null
  
)

export default component.exports